// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"678":"1844d2875260e6b0b159","731":"08c3b1fadc600bca5152","843":"571ed1b573711d0d15cf"}[chunkId] + ".js";
};